import styled from "@emotion/styled"

const Center = styled.div`text-align: center;`;

export default Center;